import {Injectable} from '@angular/core';
import {FormatOptions, FormatServiceInterface} from './interfaces/format-service.interface';
import {NumericFormatUtilsService} from './numeric-format-utils.service';
import {NumberFormatService} from './number-format.service';
import {CurrencyFormatService} from './currency-format.service';
import {DateFormatService} from './date-format.service';
import {BlankValueDisplayType, NumberDisplayType} from '../models/chart';

@Injectable()
export class FormatService implements FormatServiceInterface {
    public static selectedBlankValueType:BlankValueDisplayType = 'default';
    public static blankValueItemsMap = {
      default: 'پیش‌فرض',
      blank: '(Blank)',
      null: '(تهی)',
      dash: '-',
      notAvailable: 'N/A',
      zero: '0',
      withoutValue: 'فاقد مقدار'
    };

    constructor(private numericFormatUtilsService: NumericFormatUtilsService,
                private numberFormatService: NumberFormatService,
                private currencyFormatService: CurrencyFormatService,
                private dateFormatService: DateFormatService) {
    }

    public static getNullValuesItems(){
      const items = [];
      Object.keys(FormatService.blankValueItemsMap).forEach(key=>{
        items.push({value: key, name: FormatService.blankValueItemsMap[key]})
      });
      return items;
    }

    public static convertNullValueToPreferredText(value: string, numbersDisplayType?: NumberDisplayType): string{
      if(!value){
        return value;
      }
      if(typeof value === 'string'){
        let selectedBlankValueType = FormatService.blankValueItemsMap[FormatService.selectedBlankValueType] ||
          FormatService.blankValueItemsMap['default'];
        if (FormatService.selectedBlankValueType === 'zero') {
          selectedBlankValueType = numbersDisplayType === 'fa' ? '۰' : '0';
          }
        if (FormatService.selectedBlankValueType === 'default') {
          selectedBlankValueType = numbersDisplayType === 'fa' ? 'تهی' : 'Blank';
          }
        if(value === '__BLANK_VALUE__'){
          return selectedBlankValueType;
        }else if(value.indexOf('__BLANK_VALUE__')!==-1){
          return value.replace('__BLANK_VALUE__', selectedBlankValueType);
        }
      }
      return value;
    }

    translateNullValue(value: string, numbersDisplayType: NumberDisplayType){
      return FormatService.convertNullValueToPreferredText(value, numbersDisplayType);
    }

    formatData(data: string | number, formatOptions: Partial<FormatOptions>): string {
      if(typeof data === 'string' && data.indexOf('data:image/') !== -1){
        return data;
      }
      let formatData = data;
        if (formatData != null && data !== 'unknown') {
            if (!isNaN(+data)) {
                formatData = this.numericFormatUtilsService.formatUnit(data, formatOptions.unit, formatOptions.maxValue);
            }
            if (formatOptions.formatType === 'Default' && (formatOptions.columnDataModuleType === 'Quantity' ||
                (formatOptions.columnDataModuleType === 'Quality' && formatOptions.columnAggregationType &&
                    (formatOptions.columnAggregationType === 'Count' ||
                        formatOptions.columnAggregationType === 'DistinctCount')))) {
                formatData = this.numericFormatUtilsService.formatDecimalPoint(formatData,
                    formatOptions.decimalPointNumber, formatOptions.autoToFixed);
                if (!isNaN(+data)) {
                    formatData = this.numericFormatUtilsService.addUnitSign(formatData,
                        formatOptions.unit, formatOptions.maxValue);
                }
                formatData = this.numericFormatUtilsService.formatMinus(formatData.toString(),
                    formatOptions.formatType, formatOptions.negativeNumberFormat);
            } else if (formatOptions.formatType === 'Number') {
                formatData = this.numberFormatService.formatData(formatData, formatOptions);
            } else if (formatOptions.formatType === 'Currency') {
                formatData = this.currencyFormatService.formatData(formatData, formatOptions);
            } else if (formatOptions.formatType === 'DateTime' || formatOptions.formatType === 'Date' ||
                formatOptions.formatType === 'Time') {
                formatData = this.dateFormatService.formatData(formatData.toString(), formatOptions);
            } else if(formatOptions.formatType) {
                formatData = this.numericFormatUtilsService.formatMinus(formatData.toString(),
                    formatOptions.formatType,
                    formatOptions.negativeNumberFormat);
                if (!isNaN(+data)) {
                    formatData = this.numericFormatUtilsService.addUnitSign(formatData,
                        formatOptions.unit, formatOptions.maxValue);
                }
            } else if (!isNaN(+data)) {
                formatData = this.numericFormatUtilsService.addUnitSign(formatData,
                    formatOptions.unit, formatOptions.maxValue);
            }
            const encodedValue = this.numericFormatUtilsService.languageEncode(formatOptions.numbersDisplayType, formatData);
            return FormatService.convertNullValueToPreferredText(encodedValue, formatOptions.numbersDisplayType);
        }
        return FormatService.convertNullValueToPreferredText(data?.toString(), formatOptions.numbersDisplayType);
    }
}
